<template>
  <section id="hero">
    <!-- <v-alert type="info" style="cursor: pointer">
      <div v-on:click="onRouteToDownloads">
        {{
          $t(
            "Whoopsie! Unfortunately, for Mac users, we never provided a newer version than v1.2.2 even though we announced new versions over the last months. Sorry, this has been fixed now."
          )
        }}
      </div>
    </v-alert> -->
    <v-img
      :min-height="minHeight"
      :src="require('@/assets/home-hero.jpg')"
      class="white--text"
      gradient="to right, rgba(5, 11, 31, .7), rgba(5, 11, 31, .7)"
    >
      <v-container class="fill-height px-4 py-12">
        <v-responsive
          class="d-flex align-center"
          height="100%"
          max-width="900"
          width="100%"
        >
          <base-heading
            v-bind:title="
              $t('THE media frontend for data hoarders and movie lovers')
            "
          />

          <base-body>
            <p class="white--text" style="margin-bottom: 0px !important">
              {{
                $t(
                  "Call it what you want: Entertainment Center, Media Database or Entertainment Hub_"
                )
              }}
            </p>
            <p class="white--text">
              {{
                $t(
                  "Media Hoarder makes your media ultimately accessible and discoverable_"
                )
              }}
            </p>
            <p class="white--text">
              {{
                $t(
                  "Of course, it plays your media as well - by using the media player of your choice (e_g_ VLC)_"
                )
              }}
            </p>
          </base-body>

          <div
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'flex-column align-start'
                : 'align-center'
            "
            class="d-flex flex-wrap"
          >
            <a href="#platform-support"
              ><base-btn>{{ $t("Learn More") }}</base-btn></a
            >

            <span class="font-weight-bold ml-6 mr-4 my-4">{{ $t("or") }}</span>

            <base-btn
              to="getting-started"
              :ripple="false"
              class="pa-1"
              height="auto"
              text
              >{{ $t("Get Started Now") }}</base-btn
            >
          </div>
        </v-responsive>
      </v-container>
    </v-img>
  </section>
</template>

<script>
export default {
  name: "SectionHero",

  provide: {
    theme: { isDark: true },
  },

  computed: {
    minHeight() {
      const height = this.$vuetify.breakpoint.mdAndUp ? "100vh" : "50vh";

      return `calc(${height} - ${this.$vuetify.application.top}px)`;
    },
  },

  methods: {
    onRouteToDownloads() {
      console.log("[onRouteToDownloads] START");
      this.$router.push({
        name: "Downloads",
      });
    },
  },
};
</script>
